import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const SAFE_URL_RE = /^(https?:|mailto:|tel:|\/|data:image\/|data:application\/pdf|data:font\/)/i;

/**
 * Returns the URL only if it uses a scheme that is safe to put in an href/src.
 * Blocks javascript:/vbscript:/active data: payloads (defense in depth against
 * stored XSS via legacy records; the API also sanitizes these on write).
 */
export function safeUrl(url, fallback = undefined) {
  if (typeof url !== "string") return fallback;
  const trimmed = url.trim();
  return SAFE_URL_RE.test(trimmed) ? trimmed : fallback;
}

/** Minutos → "1h 30m" / "45m" / "—". */
export function fmtDuration(minutes) {
  const total = Math.round(Number(minutes) || 0);
  if (total <= 0) return "—";
  const h = Math.floor(total / 60);
  const m = total % 60;
  if (h && m) return `${h}h ${m}m`;
  if (h) return `${h}h`;
  return `${m}m`;
}

export const minutesToHours = (minutes) => Math.round(((Number(minutes) || 0) / 60) * 100) / 100;
export const hoursToMinutes = (hours) => Math.max(0, Math.round((Number(hours) || 0) * 60));

/** Segundos → "12:04" ou "1:03:22" (cronómetro ao vivo). */
export function fmtClock(totalSeconds) {
  const s = Math.max(0, Math.floor(Number(totalSeconds) || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const mm = String(m).padStart(2, "0");
  const ss = String(sec).padStart(2, "0");
  return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}
